import type { RepeatOrderResult } from "../types/order.dto";

export type RepeatOrderFeedback = { kind: "success" | "warning" | "error"; message: string };

/**
 * Traduz o retorno de POST /customer/orders/:id/repeat no aviso ao comprador.
 * O back adiciona só o que está vendável HOJE (preço ativo + estoque) — o
 * retorno diz o que entrou e o que ficou de fora.
 */
export function describeRepeatResult(result: RepeatOrderResult): RepeatOrderFeedback {
    if (result.addedCount === 0) {
        return {
            kind: "error",
            message: "Os itens deste pedido não estão mais disponíveis para compra.",
        };
    }
    if (result.skippedCount > 0) {
        const one = result.skippedCount === 1;
        return {
            kind: "warning",
            message:
                `${result.addedCount} de ${result.productsCount} itens adicionados — ` +
                `${result.skippedCount} ${one ? "está indisponível" : "estão indisponíveis"} e ${one ? "ficou" : "ficaram"} de fora.`,
        };
    }
    return { kind: "success", message: "Itens adicionados ao carrinho." };
}
